import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../../../src/utill/validation";
import { Collapse, Row, Space } from "antd";
import axios from "axios";
import api from "../../../src/config.json";
import Table from "../../../src/Common/table";
import dateTime from "../../../src/utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../../../src/utill/Excelimport";
import Loading from "../../../src/utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import _ from "lodash";
import moment from "moment";
import { generateExcelFile } from "../../utill/download";

const ReservoirMaster = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({
    path: "PartID",
    order: "asc",
  });

  const history = useHistory();
  const [size, setSize] = useState("lg");
  const [opStatus, setopStatus] = useState("");
  const [Operation, setOperation] = useState({});
  const [componentList, setcomponentList] = useState([]);
  const [modelState, setmodelState] = useState(false);
  const [Update, setUpdate] = useState({});
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [templateList1, setTemplateList1] = useState([]);
  const [modelState1, setmodelState1] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });
  const [ReservoirMasterList, setReservoirMasterList] = useState([]);
  const [Inputdata, setInputData] = useState({});

  const [rows, setRows] = useState([]);
  const [errors1, setErrors1] = useState({});
  const [errors, seterrors] = useState({});
  const [QRCodeVisible, setQRCodeVisible] = useState(false);
  const [PartName, setPartName] = useState("");
  const [PartNumber, setPartNumber] = useState("");
  const [ReservoirIdList, setReservoirIdList] = useState([]);
  const [PdfData, setPdfData] = useState([]);
  const [QRCodeArray, SetQRCodeArray] = useState([]);
  const [EnableAllPdf, SetEnableAllPdf] = useState(false);
  const [AdjustedQty, setAdjustedQty] = useState([]);

  const [Type, setType] = useState("");
  const [Quantity, setQuantity] = useState("");
  const [Remarks, setRemarks] = useState("");
  const [Date, setDate] = useState([]);
  const { Panel } = Collapse;
  function callback(key) {
    console.log(key);
  }
  console.log(PdfData, "vhfvhdfvbhbvd");
  const handelOnPDfEnable = (e, input) => {
    let data = [...componentList];

    if (e.currentTarget.checked) {
      // Enable the PDF and add it to the list if not already present
      const exists = data.some((item) => item._id === input._id);

      if (!exists) {
        const updatedInput = { ...input, Printed: true }; // Avoid mutating input
        data.push(updatedInput);
      } else {
        data = data.map((item) =>
          item._id === input._id ? { ...item, Printed: true } : item
        );
      }

      SetEnableAllPdf(true); // Set "EnableAllPdf" to true
    }
    if (!e.currentTarget.checked) {
      data = data.map((item) => {
        console.log("jhveffj", item._id === input._id, item, input);
        return item._id === input._id ? { ...item, Printed: false } : item;
      });
    }
    setcomponentList(data);
    console.log(e.currentTarget.checked, "sdhbsdfusd", data);
    setPdfData(data);
  };
  const handelSelectAll = (e) => {
    const isChecked = e.currentTarget.checked;

    // Update the componentList with updated 'Printed' values
    const updatedList = componentList.map((one) => ({
      ...one,
      Printed: isChecked,
    }));

    // Update state
    setcomponentList(updatedList);
    setPdfData(updatedList);
    SetEnableAllPdf(isChecked);
  };

  const columns = [
    {
      key: "select",
      label: (
        <input
          type="checkbox"
          onChange={handelSelectAll}
          checked={
            componentList.filter(
              (one) => one.QRCode == false || one.QRCode == undefined
            ).length > 0
              ? false
              : true
          }
        />
      ),

      content: (obj) => (
        <input
          type="checkbox"
          checked={obj["Printed"]}
          onChange={(e) => handelOnPDfEnable(e, obj)}
        />
      ),
    },
    { path: "Reservoir_Type", label: "Reservoir Type" },
    { path: "Reservoir_ID", label: "Reservoir Id" },
    { path: "RM_Type", label: "Expected RM Type" },

    { path: "RM_ID", label: "Expected RM ID" },

    {
      path: "createdAt",
      label: "Created Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.createdAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      path: "updatedAt",
      label: "Last Updated Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      key: "update",
      content: (user) => (
        <button
          disabled={
            !getRightsForAccess("StaticDataRights", RightName, "update")
          }
          onClick={() => {
            // setOperation(user)
            setUpdate(user);
            setopStatus("update");
          }}
          className="btn btn-sm btn-primary"
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
    },
    // { key: 'view', content: user => <button onClick={() => onView(user)} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEye} /></button> },
    {
      key: "delete",
      content: (user) => (
        <button
          disabled={
            !getRightsForAccess("StaticDataRights", RightName, "update")
          }
          onClick={() => onDelete(user)}
          className="btn btn-sm btn-danger"
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      ),
    },
  ];

  useEffect(() => {
    if (opStatus == "update") {
      setRows(Update.checkpoints);
      setQRCodeVisible(true);
      setOperation(Update);
      setmodelState(true);
    } else {
      setRows([]);
    }
  }, [opStatus]);

  useEffect(() => {
    Heading("Reservoir Master");
    getCompundList();
    getToolList();
    getCompundList1();
  }, []);
  const handleDownloadExcel = (e) => {
    generateExcelFile(e);
  };
  const handleCloseModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const handleHideModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const getCompundList = () => {
    axios
      .get(api.api + "RMMaster")
      .then((result) => {
        setReservoirMasterList(result.data);
        const list = _.uniqBy(result.data, "RM_Type");
        console.log(result.data, "csdcisdciusdi", list);
        const ReservoirTypeList = list.map((one) => ({
          Name: one.RM_Type,
          value: one.RM_Type,
        }));
        setTemplateList(ReservoirTypeList);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getCompundList1 = () => {
    axios
      .get(api.api + "RMMaster")
      .then((result) => {
        const ReservoirTypeList = result.data.map((one) => ({
          Name: one.RM_ID,
          value: one.RM_ID,
        }));
        setTemplateList1(ReservoirTypeList);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getToolList = () => {
    axios
      .get(api.api + "reservoirMaster")
      .then((result) => {
        setcomponentList(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const downloadPDF = async (qrCodeGroups, Operation) => {
    const pdf = new jsPDF("p", "mm", "b5");
    for (let i = 0; i < qrCodeGroups.length; i++) {
      const page = document.getElementsByClassName("a4-page")[i];
      const canvas = await html2canvas(page);
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      if (i < qrCodeGroups.length - 1) pdf.addPage();
    }
    pdf.save(
      `ReservoirMaster.pdf`
    );
  };
  const A4Sheet = (QRCodeVisible, Operation) => {
    // Split the QR codes into groups of 4
    const qrCodeGroups = [];
    if (QRCodeVisible) {
      const totalStickers = Number(Operation.NumOfStickers);
      for (let i = 0; i < totalStickers; i += 1) {
        qrCodeGroups.push(
          [...Array(Math.min(1, totalStickers - i))].map((_, j) => i + j)
        );
      }
    }

    // Function to download the PDF

    return (
      <div>
        <Button
          type="primary"
          onClick={() => {
            downloadPDF(qrCodeGroups, Operation);
          }}
          style={{ marginBottom: "16px" }}
        >
          Download as PDF
        </Button>
        <div className="a4-sheet-scrollable">
          {qrCodeGroups.map((group, pageIndex) => (
            <div
              className="a4-page"
              key={pageIndex}
              style={{ pageBreakAfter: "always" }}
            >
              {group.map((index) => (
                <div className="d-flex justify-content-center " key={index}>
                  <div className="p-5">
                    <QRCodeSVG
                      level="M"
                      className="d-flex justify-content-center "
                      value={JSON.stringify(Operation)}
                      size={500}
                    />
                    <h3 className="bolder text-center">
                      {Operation.Reservoir_Type}
                    </h3>
                    <h3 className="bolder text-center">{Operation.BatchNo}</h3>
                    <h3 className="bolder text-center">
                      {index + 1 + " / " + Operation.NumOfStickers}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  };
  const handleCloseModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleHideModel = () => {
    setopStatus("");
    setmodelState(false);
  };

  const handleSort = (sortColumn) => {
    if (componentList.length > 0) {
      const sorted = _.orderBy(
        componentList,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);
      setcomponentList(sorted);
    }
  };

  const schema = {
    Reservoir_Type: joi.string().required(),

    Reservoir_ID: joi.string().required(),
    RM_Type: joi.string().required(),
    RM_ID: joi.string().required(),
    Enable: joi.boolean(),
    _id: joi.string(),
  };

  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;
    const Reservoirlist = [...ReservoirMasterList];

    if (name === "Reservoir_Type") {
      setOperation((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (name === "RM_ID") {
      setOperation((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (name === "RM_Type") {
      const filteredArray = _.filter(Reservoirlist, { RM_Type: value });
      console.log(filteredArray, "vsjinjvsdihbvb", Reservoirlist, value);
      if (filteredArray.length > 0) {
        const list = filteredArray.map((one) => ({
          Name: one.RM_ID,
          value: one.RM_ID,
        }));
        setOperation((prev) => ({
          ...prev,
          ["RM_ID"]: "",
        }));
        setReservoirIdList(list);
      } else {
        console.warn("No Reservoirs found for the selected Reservoir_Type.");
        setReservoirIdList([]);
      }
      setOperation((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else {
      setOperation((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleOnChange1 = (e) => {
    const { value } = e.currentTarget;

    setPartName(value); // Merges the new value with the previous string
  };
  const handleOnChange2 = (e) => {
    const { value } = e.currentTarget;

    setPartNumber(value); // Merges the new value with the previous string
  };
  const handleOnAdd = () => {
    const test = { ...Operation };
    if (PartName.length > 0) {
      test.PartName = [...(test.PartName || []), PartName];
      setPartName("");
      setOperation(test);
    } else {
      swal("Can Not Add Blank Part Name");
    }
    // Add PartName (string) to the array in test.PartName
  };
  const handleOnAdd1 = () => {
    const test = { ...Operation };
    if (PartNumber.length > 0) {
      test.PartNumber = [...(test.PartNumber || []), PartNumber];
      setPartNumber("");
      setOperation(test);
    } else {
      swal("Can Not Add Blank Part Name");
    }
    // Add PartName (string) to the array in test.PartName
  };
  const removeRow = (index) => {
    // Create a deep copy of the `Operation` state to avoid direct mutation
    let data = { ...Operation, PartName: [...Operation.PartName] };

    // Remove the item at the specified index
    data.PartName.splice(index, 1);

    // Update the state with the modified data
    setOperation(data);
  };

  const downloadExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with headers only
    const headers = getColumnsWithoutUserInput(selectedTemplate.Columns).map(
      (column) => column.DbFieldName
    );
    headers.unshift("StandardType");
    const worksheetData = [headers];

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate and download the Excel file
    XLSX.writeFile(workbook, `${selectedTemplate.Name}_template.xlsx`);
  };

  const getColumnsWithoutUserInput = (allColumns = []) => {
    const columns = [...allColumns];
    return columns.filter((x) => !x.DataType.startsWith("UserInput"));
  };

  const handleFileUpload = (e) => {
    const fileInputElement = document.createElement("input");
    fileInputElement.type = "file";
    fileInputElement.accept = ".xlsx, .xls";
    fileInputElement.multiple = false;

    // Handle the file upload when the user selects a file
    fileInputElement.addEventListener("change", (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0];
        const rows = jsonData.slice(1);
        const formattedData = rows.map((row) => {
          let obj = {};
          row.forEach((cell, index) => {
            obj[headers[index]] = cell;
          });
          return obj;
        });
        setRows(formattedData);
        // Clean up: remove the file input element from the DOM
        fileInputElement.remove();
      };

      // Read the file as a binary string
      reader.readAsBinaryString(file);
    });

    // Programmatically trigger the file input click
    fileInputElement.click();
  };

  const onDelete = (data) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .delete(api.api + "reservoirMaster/" + data._id, { data: data })
          .then((result) => {
            getToolList();
            swal("Deleted  Successfully");
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              swal(`${err.response.data.message}`);
            } else {
              swal(`${err}`);
            }
            // toast.success(`${err}`, {
            //   position: 'bottom-right',
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   style: {
            //     background: 'red', // Set your desired background color
            //     color: 'white',     // Set your desired text color
            //   },
            // });
          });
      } else {
        // this.setState({ querySuccess: false });
        // swal("Your imaginary file is safe!");
      }
    });
  };

  const validateCheckCheckPoints = (rows = []) => {
    let errorObj = { IsError: false, message: [] };
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].StandardType == "Dimension") {
        const dimensionField = selectedTemplate.Columns.find(
          (x) => x.DataType == "StandardDimension"
        );
        if (dimensionField && !rows[i][dimensionField.DbFieldName]) {
          errorObj.IsError = true;
          errorObj.message.push(
            `Row Number ${i + 1} ${
              dimensionField.FieldName
            } is mandatory for Dimension Type check point.`
          );
          break;
        }
      }
    }
    return errorObj;
  };

  const handelSaveData = (data) => {
    // return
    const checksheet = { ...data };
    delete checksheet.__v;
    delete checksheet.createdAt;
    delete checksheet.updatedAt;
    const errors = validation.validate(checksheet, schema);
    // if (errors) {
    //   seterrors(errors);
    //   return;
    // }
    setLoader(true);
    if (opStatus == "update") {
      axios
        .patch(api.api + "reservoirMaster/" + Update._id, checksheet)
        .then((result) => {
          swal("Data Update Successfully");
          getToolList();
          setQRCodeVisible(true);

          handleCloseModel();
          setLoader(false);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    } else {
      axios
        .post(api.api + "reservoirMaster", checksheet)
        .then((result) => {
          swal("Data Saved Successfully");
          getToolList();
          handleCloseModel();
          setQRCodeVisible(true);

          setLoader(false);
          seterrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    }
  };
  const downloadPDFforAll = (data) => {
    const pdf = [];
    console.log(data, "cfekhcbfhkb");
    data.map(
      (one) =>
        one.Printed &&
        [...Array(Math.min(1))].forEach((_, j) => {
          pdf.push({
            QrCode: JSON.stringify({
              RID: one.Reservoir_ID,
              ERMID: one.RM_ID,
              UID: one.UniqueID,
            }),
            index: j,
            RID: one.Reservoir_ID,
            RM_ID: one.RM_ID,
            ExpectedRM_ID: one.ExpectedRM_ID,
            UniqueID: one.UniqueID,
            NumOfPackings: 1,
          });
        })
    );
    const qrCodeGroups = [];
    const stickersPerPage = 20; // 4x4 grid on each page
    // if (QRCodeVisible) {
    const totalStickers = Number(pdf.length);
    // const stickersPerPage = 9; // 3x3 grid on each page
    for (let i = 0; i < pdf.length; i += stickersPerPage) {
      qrCodeGroups.push(pdf.slice(i, i + stickersPerPage));
    }

    // }
    console.log("downloadPDF", data, pdf, qrCodeGroups);
    setmodelState1(true);
    SetQRCodeArray(qrCodeGroups);
  };

  const handelONaddSpare = (Date, Type, Quantity, Remarks) => {
    if (Date && Type && Quantity) {
      setAdjustedQty((prev) => [
        ...prev,
        { Date: Date, Type: Type, Qty: Quantity, Remarks: Remarks },
      ]);
    } else {
      swal("Please Fill Required Fields");
    }
    setDate("");
    setQuantity("");

    setType("");
    setRemarks("");
  };
  const handleClear = (data1, index) => {
    const data = [...AdjustedQty];
    if (index > -1) {
      // only splice array when item is found
      data.splice(index, 1); // 2nd parameter means remove one item only
    }
    setAdjustedQty(data);
  };
  return (
    <>
      {/* <div className='text-center'>
       
        <p>Checksheet Master</p>
      </div> */}
      {loader ? <Loading /> : <></>}

      <Modal
        className="custom-modal1"
        size={size}
        show={modelState}
        onHide={handleHideModel}
        backdrop={"static"}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Reservoir Master</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Operation${id}`}> */}
          <Row className="">
            <Col sm={12}>
              <div className="form-group mt-2">
                <label htmlFor="operationRejectionCost" className="fw-bold">
                  Reservoir Type
                </label>
                <AntdSelect
                  placeholder="Reservoir Type"
                  onChange={(value) => {
                    const template = templateList.find((x) => x.Name == value);
                    setSelectedTemplate(template || {});
                    handleOnChange({
                      currentTarget: { name: "Reservoir_Type", value: value },
                    });
                  }}
                  value={Operation.Reservoir_Type || []}
                  style={{ width: "100%" }}
                >
                  {[
                    { Name: "Chemical", value: "Chemical" },
                    { Name: "Carbon", value: "Carbon" },
                    { Name: "Oil", value: "Oil" },
                    { Name: "Others", value: "Others" },

                  ].map((one) => {
                    return (
                      <AntdSelect.Option value={one.Name}>
                        {one.Name}
                      </AntdSelect.Option>
                    );
                  })}
                </AntdSelect>
                {errors.Reservoir_Type && (
                  <div className="alert small alert-danger">
                    {errors["Reservoir_Type"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group form-group-sm d-flex flex-column">
                <label htmlFor="operationRejectionCost " className="fw-bold">
                  {" "}
                  Reservoir Id{" "}
                </label>
                <input
                  required
                  onChange={handleOnChange}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm w-100"
                  type="text"
                  name="Reservoir_ID"
                  value={Operation.Reservoir_ID}
                  placeholder="Enter Reservoir Id"
                />
                {errors.Reservoir_ID && (
                  <div className="alert small alert-danger">
                    {errors["Reservoir_ID"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2">
                <label htmlFor="operationRejectionCost" className="fw-bold">
                  Expected Raw Material Type
                </label>
                <AntdSelect
                  placeholder="Expected Reservoir Type"
                  onChange={(value) => {
                    const template = templateList.find((x) => x.Name == value);
                    setSelectedTemplate(template || {});
                    handleOnChange({
                      currentTarget: { name: "RM_Type", value: value },
                    });
                  }}
                  value={Operation.RM_Type || []}
                  style={{ width: "100%" }}
                >
                  {templateList.map((one) => {
                    return (
                      <AntdSelect.Option value={one.Name}>
                        {one.Name}
                      </AntdSelect.Option>
                    );
                  })}
                </AntdSelect>
                {errors.RM_Type && (
                  <div className="alert small alert-danger">
                    {errors["RM_Type"]}
                  </div>
                )}
              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2">
                <label htmlFor="operationRejectionCost" className="fw-bold">
                  Expected Raw Material Id
                </label>
                <AntdSelect
                  placeholder="Expected Reservoir Id"
                  onChange={(value) => {
                    const template = templateList.find((x) => x.Name == value);
                    setSelectedTemplate(template || {});
                    handleOnChange({
                      currentTarget: { name: "RM_ID", value: value },
                    });
                  }}
                  value={Operation.RM_ID || []}
                  style={{ width: "100%" }}
                >
                  {ReservoirIdList.map((one) => {
                    return (
                      <AntdSelect.Option value={one.Name}>
                        {one.Name}
                      </AntdSelect.Option>
                    );
                  })}
                </AntdSelect>
                {errors.RM_ID && (
                  <div className="alert small alert-danger">
                    {errors["RM_ID"]}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel()}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              const error = validateCheckCheckPoints(rows);
              if (error.IsError) {
                swal("ERROR", error.message.join(", "), { dangerMode: true });
              } else {
                handelSaveData(Operation);
              }
            }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="d-flex float-left mb-2">
        <Modal
          backdrop={"static"}
          className=""
          size={size}
          show={modelState1}
          onHide={handleHideModel1}
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-center"> Reservoir Master QR PDF</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}

            <div className="a4-sheet">
              {
                QRCodeArray && QRCodeArray.length > 0 && (
                  <div>
                    <Button
                      type="primary"
                      onClick={() => downloadPDF(QRCodeArray, Inputdata)}
                      style={{ marginBottom: "16px" }}
                    >
                      Download as PDF
                    </Button>
                    <div
                      style={{ overflowY: "scroll", height: "72vh" }}
                      className=""
                    >
                      {QRCodeArray.map((group, index) => (
                        <div className="a4-sheet-scrollable">
                          <div
                            className="a4-page"
                            // key={pageIndex}
                            style={{ pageBreakAfter: "always" }}
                          >
                            <div
                                                       style={{
                                                         display: "grid",
                                                         gridTemplateColumns: `repeat(${Math.sqrt(
                                                           16
                                                         )}, 1fr)`, // 3 columns in each row
                                                         gridTemplateRows: `repeat(${Math.sqrt(
                                                           16
                                                         )}, auto)`, // 3 rows per page (auto height)
                                                         gap: "57px", // Optional: Adjust the gap between items as needed
                                                         justifyItems: "center",
                                                         alignItems: "center",
                                                       }}
                                                     >
                                                       {group.map((one, index) => (
                                                         <div
                                                           className="d-flex flex-column justify-content-center align-items-center "
                                                           key={index}
                                                           style={{ textAlign: "center",marginBottom:'10px'}}
                                                         >
                                                           <QRCodeSVG
                                                             value={one.QrCode}
                                                             level={'M'}
                                                             size={80}
                                                             style={{marginBottom:'3px'}}
                                                           />{" "}
                                  {/* Adjust the size of the QR code */}
                                  <p
                                    style={{
                                      fontSize: "9px",
                                      color: "black",
                                      letterSpacing: "0.5px",
                                      lineHeight: "1.2",
                                    }}
                                    className="bolder p-0 m-0"
                                  >
                                    {one.UniqueID}
                                    <br />
                                    {one.RID}

                                    <br />
                                    {/* {`${1 + one.index} / ${one.NumOfPackings}`} */}
                                  </p>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )
                // [...Array(Number(Inputdata.NumOfPackings))].map((_, index) => (
                //   <Space className="qr-space" key={index} direction="vertical" align="center">
                //     <QRCodeSVG value={JSON.stringify(Inputdata)} size={100} />
                //     <p>{index + 1 + ' / ' + Inputdata.NumOfPackings}</p>
                //   </Space>
                // ))
              }
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => handleCloseModel1()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {PdfData && PdfData.length > 0 && EnableAllPdf && (
          <button
            type="button"
            className="btn-sm btn-primary ml-2 mt-2"
            onClick={() => downloadPDFforAll(PdfData)}
          >
            Reservoir Master (pdf)
          </button>
        )}
        {
          <button
            disabled={
              !getRightsForAccess("StaticDataRights", RightName, "write")
            }
            className="btn-sm btn-success ml-2 mt-2"
            onClick={() => {
              setmodelState(true);
              setOperation({});
              setUpdate({});
              setSelectedTemplate({});
            }}
          >
            Create New Reservoir Master
          </button>
        }
        {/* <button type="button" className="btn-sm btn-primary  mx-2" 
    onClick={()=>handleUploadGuagesDoc()}
    >
      <FontAwesomeIcon icon={faFileImport} /> Import Excel</button>  */}
        {getRightsForAccess("StaticDataRights", RightName, "write") && (
          <Excelimport getToolList={getToolList} API={"reservoirMaster"} handelUpdate={()=>getToolList()} />
        )}
      </div>
      <div className="">
            <button   onClick={() => handleDownloadExcel("ReservoirTemplate")}className="btn-sm btn-primary ml-2 mt-2">Download Template</button>
        </div>
        <div style={{display:'none'}}>
          <table id="ReservoirTemplate">
            <thead>
              <tr class>
             
                <th >Reservoir_Type</th>
                <th >Reservoir_ID</th>
                <th >RM_Type</th>
                <th >RM_ID</th>
               
              </tr>
            </thead>
          </table>
        </div>
      {componentList.length < 0 ? (
        "Data Not Available"
      ) : (
        <Table
          columns={columns}
          onSort={handleSort}
          sortColumn={sortColumn}
          data={componentList}
        />
      )}
    </>
  );
};

export default ReservoirMaster;
